import { MatoItem } from "@api/throughShipment/externalOrderApi";
import useIntRouteParam from "@hooks/useIntRouteParam";
import {
  externalOrderState,
  fetchExternalOrderInfo,
  fetchSendOrderNotify,
  fetchUpdateExternalOrder,
  setIsEditOrder,
  fetchExternalOrdersRevenue,
} from "@redux/externalOrderSlice";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch } from "src/store";

import ContractDetail from "./OrderDisplayComponent/ContractDetail";
import OrderDeductionSection from "./OrderDisplayComponent/OrderDeductionSection";
import OrderInfoTable from "./OrderDisplayComponent/OrderInfoTable";
import OrderProductTable from "./OrderDisplayComponent/OrderProductTable";
import OrderSummaryTable from "./OrderDisplayComponent/OrderSummaryTable";
import { Divide, Footer, CustomFooterButton, NormalTitle, Row, WrapperPreview } from "./OrderDisplayComponent/style";
import UploadFileButton from "./UploadFileButton";

type Props = {
  onBackStep: () => void;
};

export default function OrderPreview(props: Props) {
  const { onBackStep } = props;

  const dispatch = useAppDispatch();
  const { externalOrderInfo, externalOrdersRevenueResult } = useSelector(externalOrderState);
  const externalOrdersRevenueLists = externalOrdersRevenueResult?.results ?? [];

  const externalOrderId = useIntRouteParam("externalOrderId", true);

  const [matoL, setMatoL] = useState<MatoItem[]>([]);

  const regionForeign = externalOrderInfo?.retailerRegionType === "境外通路";

  useEffect(() => {
    setMatoL(externalOrderInfo?.matoL ?? []);
  }, [externalOrderInfo?.matoL]);

  useEffect(() => {
    dispatch(fetchExternalOrderInfo(externalOrderId));
    dispatch(fetchExternalOrdersRevenue(externalOrderId));
  }, [dispatch, externalOrderId]);

  if (!externalOrderInfo) {
    return null;
  }

  return (
    <WrapperPreview>
      <ContractDetail externalOrderInfo={externalOrderInfo} showWarehouse />
      <Divide />
      <OrderDeductionSection externalOrderInfo={externalOrderInfo} />
      <Divide />
      <OrderProductTable
        externalOrderInfo={externalOrderInfo}
        externalOrderId={externalOrderId!}
        mode="preview"
        regionForeign={!!regionForeign}
      />
      <Row marginTop="20px">
        <OrderSummaryTable
          externalOrderInfo={externalOrderInfo}
          externalOrdersRevenueLists={externalOrdersRevenueLists}
          usePackageSet
        />
      </Row>
      <Row marginTop="20px">
        <NormalTitle>上傳麥頭</NormalTitle>
        <UploadFileButton value={matoL} onUpload={setMatoL} isSend={externalOrderInfo?.isSend} />
      </Row>
      <Divide />
      <OrderInfoTable externalOrderInfo={externalOrderInfo} title="預估訂單營收/成本/毛利總覽" type="expected" />

      <Footer>
        <CustomFooterButton marginRight="12px" onClick={onBackStep}>
          返回
        </CustomFooterButton>
        <CustomFooterButton
          type="primary"
          disabled={externalOrderInfo.isSend}
          onClick={async () => {
            if (matoL.length > 0) {
              await dispatch(
                fetchUpdateExternalOrder({
                  externalOrderId,
                  matoL,
                }),
              );
            }
            dispatch(fetchSendOrderNotify(externalOrderId));
            dispatch(setIsEditOrder(false));
          }}
        >
          發送訂單審核通知
        </CustomFooterButton>
      </Footer>
    </WrapperPreview>
  );
}
